import { AbstractControl, ValidatorFn } from '@angular/forms';
import { getDaysDifference } from '@nagel-utils';

export class DateRangeValidators {
    static isDateRangeValidValidator = (startDateKey: string, endDateKey: string): ValidatorFn => {
        return (control: AbstractControl): { [key: string]: unknown } | null => {
            const startDate = control.get(startDateKey)?.value;
            const endDate = control.get(endDateKey)?.value;

            if (startDate && endDate) {
                const parsedStartDate = new Date(startDate);
                const parsedEndDate = new Date(endDate);

                if (parsedStartDate > parsedEndDate) {
                    return { invalidDateRange: true };
                }
            }

            return null;
        };
    };

    static isDateRangeExceedsLimitValidator = (startDateKey:string, endDateKey: string, limit: number): ValidatorFn => {
        return (control: AbstractControl): { [key: string]: unknown } | null => {
            const startDate = control.get(startDateKey)?.value;
            const endDate = control.get(endDateKey)?.value;

            if (startDate && endDate) {
                const parsedStartDate = new Date(startDate);
                const parsedEndDate = new Date(endDate);

                if (getDaysDifference(parsedStartDate, parsedEndDate) >= limit) {
                    return { dateRangeExceedsLimit: true };
                }
            }

            return null;
        };
    };
}